import BaseCollection from "nexia_mobile/models/base_collection";
import Pageable from "nexia_mobile/models/mixins/pageable";

class NewsCollection extends BaseCollection {}

_.extend(NewsCollection.prototype, Pageable);

export default NewsCollection;



// WEBPACK FOOTER //
// ./src/models/news_collection.js